import { render, staticRenderFns } from "./DetailEnrollCourse.vue?vue&type=template&id=ee3d5a10"
import script from "../../services/teacher/detail-enroll-course.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/detail-enroll-course.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/detail-course.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports